export default __webpack_public_path__ + "static/media/pantrolarge.e060504e.jpeg";